import { useQuery } from '@tanstack/react-query';
import { fetchMyCorrections } from '../api/myCorrectionsApi';
import { correctionKeys } from './correctionKeys';

export function useMyCorrections() {
  return useQuery({
    queryKey: correctionKeys.my(),
    queryFn: () => fetchMyCorrections(),
  });
}
